DJ.addBehavior('sidebar', '.sidebar', {
  attach: function(context, settings, behavior) {

    jQuery('.js-sidebar-title').each(function () {
      jQuery('.js-mobile-links').append('<div class="js-mobile-link">' + jQuery(this).text() + '</div>');
    });

    jQuery(document).on('click', '.js-mobile-link', function () {
      var index = jQuery(this).index();
      jQuery('.js-mobile-link').removeClass('active');
      jQuery('.js-article-section').removeClass('active');
      jQuery(this).addClass('active');
      jQuery('.js-article-section').eq(index).addClass('active');
    });

    jQuery('.js-mobile-link').eq(0).trigger('click');

  },

  detach: function(context, settings) {}
});
